"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonDropdown = function ButtonDropdown(_ref) {
  var variant = _ref.variant,
      label = _ref.label,
      options = _ref.options,
      widthButton = _ref.widthButton,
      subtitle = _ref.subtitle,
      disabled = _ref.disabled;

  var renderDropdownItem = function renderDropdownItem(item) {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
      onClick: item.onClick,
      className: "item-container",
      disabled: item.disabled
    }, item.icon && /*#__PURE__*/_react.default.createElement("span", {
      className: "icon"
    }, item.icon), item.label);
  };

  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown, {
    className: "buttonDropdown"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Toggle, {
    variant: variant,
    id: "dropdown-basic",
    className: "buttonDropdown-label",
    style: {
      width: widthButton || 'auto'
    },
    disabled: disabled
  }, label), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Menu, null, subtitle ? /*#__PURE__*/_react.default.createElement("div", {
    className: "subtitle"
  }, subtitle) : null, options.map(function (opt) {
    return opt.tooltipText ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
      key: opt.placement,
      placement: opt.tooltipPlacement,
      delay: {
        show: 250,
        hide: 400
      },
      overlay: /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tooltip, {
        id: "tooltip-".concat(opt.tooltipPlacement)
      }, opt.tooltipText)
    }, renderDropdownItem(opt)) : renderDropdownItem(opt);
  })));
};

var _default = ButtonDropdown;
exports.default = _default;
ButtonDropdown.propTypes = {
  variant: _propTypes.default.oneOf(['info', 'primary', 'secondary', 'success', 'dark', 'warning', 'dropdown-gray']),
  label: _propTypes.default.string.isRequired,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired,
    icon: _propTypes.default.element,
    disabled: _propTypes.default.bool,
    tooltipText: _propTypes.default.string,
    tooltipPlacement: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left'])
  })),
  subtitle: _propTypes.default.string,
  widthButton: _propTypes.default.string,
  disabled: _propTypes.default.bool
};
ButtonDropdown.defaultProps = {
  variant: 'dropdown-gray',
  options: [{
    icon: null,
    disabled: false,
    tooltipPlacement: 'top'
  }],
  subtitle: '',
  disabled: false
};